import Volleyball_01 from 'assets/images/pictures/volleyball/volleyball_01.jpg';
import Volleyball_02 from 'assets/images/pictures/volleyball/volleyball_02.jpg';
import Volleyball_03 from 'assets/images/pictures/volleyball/volleyball_03.jpg';
import Volleyball_04 from 'assets/images/pictures/volleyball/volleyball_04.jpg';
import Volleyball_05 from 'assets/images/pictures/volleyball/volleyball_05.jpg';
import Volleyball_06 from 'assets/images/pictures/volleyball/volleyball_06.jpg';
import Volleyball_07 from 'assets/images/pictures/volleyball/volleyball_07.jpg';
import Volleyball_08 from 'assets/images/pictures/volleyball/volleyball_08.jpg';
import Volleyball_09 from 'assets/images/pictures/volleyball/volleyball_09.jpg';
import Volleyball_10 from 'assets/images/pictures/volleyball/volleyball_10.jpg';
import Volleyball_11 from 'assets/images/pictures/volleyball/volleyball_11.jpg';
import YoutubeEmbed from 'assets/videos/YoutubeEmbed';

const VolleyballSlides = [
  // {
  //   id: 0,
  //   component: (
  //     <YoutubeEmbed
  //       embedId='JgM_l3yPdK4?si=CqtxlzgdyFdM9EIG'
  //       title='活力秘技'
  //     />
  //   ),
  // },
  {
    id: 1,
    component: (
      <img
        src={Volleyball_01}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Volleyball 01'
      />
    ),
  },
  {
    id: 2,
    component: (
      <img
        src={Volleyball_02}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Volleyball 02'
      />
    ),
  },
  {
    id: 3,
    component: (
      <img
        src={Volleyball_03}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Volleyball 03'
      />
    ),
  },
  {
    id: 4,
    component: (
      <img
        src={Volleyball_04}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Volleyball 04'
      />
    ),
  },
  {
    id: 5,
    component: (
      <img
        src={Volleyball_05}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Volleyball 05'
      />
    ),
  },
  {
    id: 6,
    component: (
      <img
        src={Volleyball_06}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Volleyball 06'
      />
    ),
  },
  {
    id: 7,
    component: (
      <img
        src={Volleyball_07}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Volleyball 07'
      />
    ),
  },
  {
    id: 8,
    component: (
      <img
        src={Volleyball_08}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Volleyball 08'
      />
    ),
  },
  {
    id: 9,
    component: (
      <img
        src={Volleyball_09}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Volleyball 09'
      />
    ),
  },
  {
    id: 10,
    component: (
      <img
        src={Volleyball_10}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Volleyball 10'
      />
    ),
  },
  {
    id: 11,
    component: (
      <img
        src={Volleyball_11}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Volleyball 11'
      />
    ),
  },
];

export default VolleyballSlides;
